module.exports = __webpack_public_path__ + "static/media/Google_Play_Store.ef9ef08d.png";